import { CustomElement } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { TypedWebComponentOptions, WebComponentOptions } from "@cervval.js/client-html5-core/src/components/typedWebComponentOptions.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import { toggleVisible } from "@cervval.js/client-html5-core/src/tools/css.tools";
import { FLEX_CONTAINER_COLUMN, FLEX_ITEM_AUTO, JUSTIFY_CONTENT, PADDING } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { empty, setHTMLElementContent } from "@cervval.js/client-html5-core/src/tools/dom.tools";
import { getLogConsole } from "@cervval.js/common/src/services/log.service";
import { getVOFValue } from "@cervval.js/common/src/tools/object.tools";
import { CjsButton } from "../button/button";
import { CjsIconFa } from "../icon/iconFa";
import { EMPTY_STATE_PRE_CONFIGS, EmptyStateDisplayConfig, EmptyStateDisplayOptions } from "./emptyStateDisplay.types";


@CustomElement({
    name: "cjs-empty-state",
    template: require("./emptyStateDisplay.html"),
    style: require("./emptyStateDisplay.scss"),
    elementCssClasses: [FLEX_ITEM_AUTO, FLEX_CONTAINER_COLUMN, JUSTIFY_CONTENT.CENTER, PADDING.PX_2, PADDING.PY_2]
})
export class CjsEmptyStateDisplay extends WebComponent {

    @TypedWebComponentOptions()
    public readonly options!: WebComponentOptions<EmptyStateDisplayOptions>;

    @TypedHtmlElements({ ensureLoadedClasses: [CjsIconFa] })
    public readonly _components!: {
        emptyStateIcon: CjsIconFa,
        emptyStateTitle: HTMLDivElement,
        emptyStateDesc: HTMLDivElement,
        emptyStateButtons: HTMLDivElement
    };

    constructor(options?: Partial<EmptyStateDisplayOptions>) {
        super();
        this.options.setWithoutRefresh(options);
    }

    /** @inheritdoc */
    public override refresh(): void {

        const iconOptions = this._getConfigValue("iconOptions");
        if (iconOptions != null) {
            toggleVisible(this._components.emptyStateIcon, true);
            this._components.emptyStateIcon.options.setAndRefreshIfChanged(iconOptions);
        } else {
            toggleVisible(this._components.emptyStateIcon, false);
        }

        const title = getVOFValue(this._getConfigValue("title"));
        const description = getVOFValue(this._getConfigValue("description"));

        if (title == null || description == null) {
            getLogConsole().warn("[CjsEmptyStateDisplay] Title or description missing for rendering");
            return;
        }
        setHTMLElementContent(this._components.emptyStateTitle, title);
        setHTMLElementContent(this._components.emptyStateDesc, description);

        const actionButtons = this._getConfigValue("actionButtons") ?? [];
        toggleVisible(this._components.emptyStateButtons, actionButtons.length > 0);
        empty(this._components.emptyStateButtons);
        for (const btnConfig of actionButtons ?? []) {
            const btn = new CjsButton({
                ...btnConfig.options
            });
            btn.clickEvent.on(btnConfig.onClick.handleEvent);
            this._components.emptyStateButtons.append(btn);
        }
    }

    /** Retrieve a config value */
    protected _getConfigValue<Key extends keyof EmptyStateDisplayConfig>(config: Key): EmptyStateDisplayOptions[Key] | undefined {
        return EMPTY_STATE_PRE_CONFIGS[this.options.preConfig!]?.[config] ?? this.options[config];
    }

}